import { Box, Button, Container, Grid, Theme, Typography } from "@material-ui/core";
import StringUtil from "../../../app/util/StringUtil";
import FlexNewLine from "../../cmp/flex/FlexNewLine";
import useWizardFormCtx from "../wizard/ctx-provider/useWizardFormCtx";
import { makeStyles } from "@material-ui/styles";
import Video from "../homepage/Video";
import BtnTarifrechner from "../homepage/BtnTarifrechner";
import React from "react";
import useGtmPageView from "../../usePageview";
import DLayerPageviewTitle from "../../../gtm/types/GtmPageviewTitleId";
import Grund from "./Grund";
import Images from "../../../assets/images";
import useAppCtx from "../../../app/ctx-provider/useAppCtx";
import StvPage from "../../../app/ctx-provider/StvPage";
import CheckIcon from '@material-ui/icons/Check';
import FAQ from "./FAQ";
import Produkt from "../wizard/step-angebot/produkt/Produkt";
import { PreisBubble } from "./PreisBubble";

const useStyle = makeStyles((theme: Theme) => ({
    newLine: {
        marginTop: 30
    },

    subtitle1: {
        fontFamily: theme.typography.subtitle1.fontFamily
        
    },
    textLink: {
        color: theme.palette.primary.main,
        textTransform: 'none',
        fontFamily: theme.typography.h5.fontFamily,
        fontSize: theme.typography.h5.fontSize,
        textDecoration: 'none',
        borderBottom: '2px solid',
        borderRadius: 0,
        background: 'inherit',
        padding: 0,
        "&:hover": {
            opacity: 0.7,
            transition: 'all 0.3s',
            background: 'inherit',
            textDecoration: 'none',
        }
    },
    imgGalleryItemTuev: {
        maxHeight: 80,
        width: 'auto',
        [theme.breakpoints.down('sm')]: {
            maxHeight: 60,
        }
    },
    imgGalleryItem: {
        maxHeight: 94,
        width: 'auto',
        [theme.breakpoints.down('sm')]: {
            maxHeight: 94,
        }
    },
    vorteilBox: {
        backgroundColor: theme.palette.secondary.main,
        background: 'linear-gradient(180deg, rgba(0,159,109,1) 0%, rgba(28,96,68,1) 100%)',
        color: '#ffffff',
        zIndex: 1,
        [theme.breakpoints.down('sm')]: {
            maxWidth: '82%',
        }
    },
    preisBox: {
        zIndex: 0,
        position: 'relative',
        maxWidth: 315,
        marginLeft: 110,
        marginTop: 10,
        [theme.breakpoints.down('sm')]: {
            marginLeft: 110,
        }
    },
    preisBoxSternchenText: {
        paddingTop: 94, 
        textAlign: 'right',
        [theme.breakpoints.down('sm')]: {
            marginLeft: -110,
            textAlign: 'center',
        }
    },
    dackel: {
        width: 246,
        marginLeft: -49,
        marginTop: 2,
        marginBottom: 46,
    },
    vorteilBoxHeadline: {
        maxWidth: 500,
        [theme.breakpoints.down('sm')]: {
            maxWidth: 212,
        },
    },
    vorteilBoxButtonAbschliessen: {
        color: theme.palette.secondary.main,
        backgroundColor: '#ffffff',
        textTransform: 'none', 
        fontWeight: 700, 
        borderRadius: 0, 
        flexGrow: 1, 
        height: 50
    },
    vorteilBoxButtonBerechnen: {
        textTransform: 'none', 
        fontWeight: 700, 
        borderRadius: 0, 
        flexGrow: 1,
         height: 50
    },
    checkIcon: {
        width: '20px',
        marginRight: '8px',
        verticalAlign: 'bottom',
    },
    wrapper: {
        paddingLeft: 0,
        justifyContent: 'left',
        [theme.breakpoints.up('sm')]: {
            paddingLeft: 54
        },
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center',
        }
    },
    fuenfminbadge: {
        borderRadius: '50%', 
        border: '3px solid #ffffff', 
        backgroundColor: 'orange', 
        background: 'linear-gradient(98deg, rgba(255,179,0,1) 0%, rgba(254,84,0,1) 100%)', 
        color: '#ffffff', 
        display: 'flex', 
        height: '90px', 
        width: '90px', 
        zIndex: 500, 
        transform: 'rotate(-14deg)', 
        padding: 5, 
        alignItems: 'center', 
        justifyContent: 'center', 
        textAlign: 'center', 
        position: 'absolute', 
        top: 15, 
        right: -60,
        [theme.breakpoints.down('xs')]: {
            top: -17, 
            right: 0,
        }
    },
    produktSpalteLinks: {
        "& > div": {
            border: '2px solid #eaeaea',
        },
        [theme.breakpoints.up('md')]: {
            paddingLeft: '10%'
        },
        [theme.breakpoints.up('lg')]: {
            paddingLeft: '20%'
        },
    },
    produktSpalteRechts: {
        "& > div": {
            border: '2px solid #eaeaea',
        },
        [theme.breakpoints.up('md')]: {
            paddingRight: '10%'
        },
        [theme.breakpoints.up('lg')]: {
            paddingRight: '20%'
        }
    },
    back1: {
        backgroundColor: '#cce4f0',
        background: 'linear-gradient(180deg, rgba(204,228,240,1) 0%, rgba(204,228,240,1) 88%, rgba(255,255,255,1) 88%)',
    },
    back2: {
        backgroundColor: '#ffffff',
    },
    back3: {
        backgroundColor: '#cce4f0',
    },
    backgroundBar: {
        backgroundColor: 'rgba(164,201,220,1)',
        zIndex: 0,
        position: 'absolute',
        width: '100%',
        height: 93,
        top: 333,
        [theme.breakpoints.down('sm')]: {
            height: 93,
            top: 450,
        }
    },
    schildMitHund: {
        zIndex: 1,
        left: -60,
        top: 110,
        width: 108,
        position: 'absolute',
    },

}));

const NewLine: React.FC = () => {
    const classes = useStyle();
    return (<FlexNewLine className={classes.newLine} />);
}

const HomepageFacelift: React.FC = () => {
    const { wizardFormBo } = useWizardFormCtx();
    useGtmPageView(DLayerPageviewTitle.HOMEPAGE_FACELIFT);
    const classes = useStyle();
    const { appCtxBo, setAppCtxBo } = useAppCtx();

    const name = wizardFormBo.antrag.vnName || undefined;
    const vorname = wizardFormBo.antrag.vnVorname || undefined;

    const prName = StringUtil.trim(`${vorname || ''} ${name || ''}`);
    const renderName = !StringUtil.isBlank(prName);

    const onClick = () => {
        appCtxBo.currentPage = StvPage.WIZARD;
        setAppCtxBo(appCtxBo);
    }

    return (
        <React.Fragment>
                <div className={classes.backgroundBar} ></div>
                <div className={classes.back1}>
                <Container>                    
                        <Box className={classes.wrapper} style={{ display: 'flex', flexWrap: 'wrap' }}>

                            <Box style={{ textAlign: 'left', display: 'flex', flexDirection: 'column'}}>
                                <Box style={{ textAlign: 'left', display: 'flex', flexDirection: 'row', alignItems: 'end' }}>
                                    <Box style={{ display: 'flex', flexDirection: 'column' }}>
                                    {renderName ? <Typography variant='h1' style={{fontWeight: 700}} color='textPrimary'>Hallo <span style={{ fontWeight: 'bold' }}>{prName}</span>!</Typography> : <Typography variant='h1' style={{fontWeight: 700}} color='textPrimary'>Jetzt neu:</Typography>}
                                        <Typography variant='h1' color='textPrimary'>Hunde-Haftpflicht+</Typography>
                                        <Typography variant='h5' color='textPrimary' style={{ marginTop: 10 }}>Wenn Sie das beste für Ihren Hund wollen</Typography>
                                    </Box>
                                    <Box style={{ alignItems: 'end', paddingLeft: 30 }}>
                                        <img className={classes.imgGalleryItemTuev} src={Images.tuev} alt="RheinLand Versicherungsgruppe Testmark" />
                                    </Box>
                                </Box>

                                <Box className={classes.vorteilBox} style={{marginTop: 28, padding: 18, paddingTop: 0, position: 'relative' }}>
                                    <Typography variant='h5' className={classes.vorteilBoxHeadline} style={{ marginTop: 10, marginBottom: 20}}>Die Vorteile der Hunde&shy;halter-Haftpflicht&shy;versicherung.</Typography>
                                    <Typography variant='h6'><CheckIcon className={classes.checkIcon} />Ersetzt <b>Schäden bis zu 20 Mio.</b> Euro</Typography>
                                    <Typography variant='h6'><CheckIcon className={classes.checkIcon} />Wehrt unberechtigte Schadens&shy;ersatz&shy;forderungen ab</Typography>
                                    <Typography variant='h6'><CheckIcon className={classes.checkIcon} />Leistung auch bei Führen ohne Leine oder Maulkorb</Typography>
                                    <Box style={{marginTop: 20, display: 'flex', justifyContent: 'space-between', gap: 20}}>
                                        <Button onClick={onClick} variant='contained' color='secondary' size='large' className={classes.vorteilBoxButtonBerechnen}>Beitrag berechnen</Button>
                                        <Button onClick={onClick} variant='contained' size='large' className={classes.vorteilBoxButtonAbschliessen}>Jetzt abschließen</Button>
                                    </Box>
                                    <Box className={classes.fuenfminbadge} ><Typography variant='h6'>in weniger<br/>als <b>5 Min.</b><br/>versichert.</Typography></Box>
                                </Box>
                            </Box>
                            
                            <Box className={classes.preisBox}>
                                    <img className={classes.dackel} src={Images.dackel} alt="Hunde-Haftpflicht Plus" />
                                    <PreisBubble />
                                    <img className={classes.schildMitHund} src={Images.schild} alt="Hunde-Haftpflicht Plus" />
                                    <Box className={classes.preisBoxSternchenText}>
                                        <Typography variant='h6' color='textPrimary' style={{fontSize: 12}}>*Preis für 10 Mio Euro Versicherungssumme bei 150 Euro<wbr /> Selbstbeteiligung, ohne Schutzbrief</Typography>
                                    </Box>
                            </Box>
                            <NewLine />

                            <NewLine />

                            <Box style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
                                <Box style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 20}}>
                                    <Grund title="140 Jahre" subtitle="Versicherungskompetenz" showDivider={true} />
                                    <Grund title="Kontinuität" subtitle="Seit 1880 in Familienbesitz" showDivider={true} />
                                    <Grund title="Umweltschutz" subtitle="Schon immer umweltbewusst" showDivider={true} />
                                    <Grund title="272 Berater" subtitle="Fachkompetenz" showDivider={false} />
                                </Box>
                            </Box>

                            <NewLine />
                            <NewLine />

                            <Box>
                                <Typography variant='h1' style={{fontWeight: 700}} color='textPrimary'>Das Plus für alle &bdquo;Felle&ldquo;</Typography>
                                <Typography variant='h5' color='textPrimary' style={{ marginTop: 10, padding: 0 }}>Hunde-Haftpflicht plus Schutzbrief - <Button onClick={onClick} className={classes.textLink}>einfach online abschließen</Button></Typography>
                                <Typography color='primary' variant='body2' style={{ textAlign: 'left', paddingTop: 20}}>
                                    Ein Hund ist nicht nur ein Haustier. Er ist Spielgefährte, Seelentröster und vor allem: ein vollwertiges Familienmitglied. 
                                    Weil aber selbst die liebsten und kleinsten Vierbeiner hin und wieder Unfug im Kopf haben, lohnt sich eine Haftpflichtversicherung für Hundehalter*innen. 
                                    <br /><br />Egal ob zerfetzte Sofas bei den Nachbarn, zerkratzte Türen bei der Verwandtschaft oder sogar ein verursachter Fahrradsturz – mit der RheinLand Hundehaftpflicht sind Sie TOPversichert.
                                    <br /><br />Und mit dem Hundeschutzbrief sichern Sie sich hilfreiche Hilfen und Services für den Alltag mit Hund. Sie profitieren von tollen Leistungen wie Betreuungsservice bei Krankheit des Besitzers, Sprechstunden bei einem digitalen Tierarzt oder Beratung zu Einreise und Impfpflichte für den nächsten Urlaub.
                                    <br /><br />Informieren Sie sich jetzt über unsere Hundehalterhaftpflicht und den Hundeschutzbrief, damit Sie bei den nächsten „Abenteuern“ bestens abgesichert sind.
                                </Typography>
                            </Box>
                            <NewLine />
                                
                            <Box style={{width: '100%', textAlign: 'center', minHeight: 315}}>
                                <Video />
                            </Box>
                        </Box>

                </Container>
            </div>
            <div className={classes.back2}>
                <Container>                    
                    <Box className={classes.wrapper} style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left' }}>
                    
                            <NewLine />

                            <Box style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
                                <Box style={{textAlign: 'center', display: 'flex', flexDirection: 'column', width: 'fit-content', gap: 20}}>
                                    <Box style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: 20}}>
                                        <img className={classes.imgGalleryItem} src={Images.ascore} alt="RheinLand Versicherungsgruppe score" />
                                        <img className={classes.imgGalleryItem} src={Images.tuev} alt="RheinLand Versicherungsgruppe Testmark" />
                                    </Box>
                                    <BtnTarifrechner />
                                </Box>
                            </Box>

                            <NewLine />

                            <Box style={{width: '100%', textAlign: 'center'}}>
                                <Typography variant='h1' color='textPrimary'>Leistung der Hundehalter-Haftpflicht</Typography>                                
                                
                            </Box>

                            <Grid container spacing={0} className="hans">
                                <Grid item xs={12} md={6} style={{width: 'auto', margin: 'auto'}} className={classes.produktSpalteLinks}>
                                    {/* Produkt OHNE Schutzbrief */}
                                    <Produkt loading={false} mobileVersion={false} mitSchutzbrief={false} active={false}
                                        btn={<></>} infoOnly={true} />
                                </Grid>

                                <Grid item xs={12} md={6} style={{width: 'auto', margin: 'auto'}} className={classes.produktSpalteRechts}>
                                    {/* Produkt MIT Schutzbrief */}
                                    <Produkt loading={false} mobileVersion={false} mitSchutzbrief={true} active={false}
                                        btn={<></>} infoOnly={true} />
                                </Grid>
                            </Grid>

                            <NewLine />

                            <Box style={{width: '100%', textAlign: 'center'}}>
                                <BtnTarifrechner />
                            </Box>

                            <NewLine />

                    </Box>
                </Container>

            </div>
            <div className={classes.back3}>
                <Container>                    
                    <Box className={classes.wrapper} style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'left' }}>
                        <NewLine />

                        <Box style={{width: '100%', textAlign: 'center'}}>
                            <Typography variant='h1' color='textPrimary'>FAQ - das fragen Kunden</Typography>                                
                            <FAQ />
                        </Box>
                    </Box>
                </Container>
            </div>
        </React.Fragment>
    );
}

export default HomepageFacelift;